/**
 * Champ de saisie + dropdown de suggestions d'ingrédients
 */

import React from "react";
import { HiOutlinePlus } from "react-icons/hi2";

export default function IngredientInputWithSuggestions({
  currentIngredient,
  setCurrentIngredient,
  showIngredientSuggestions,
  setShowIngredientSuggestions,
  ingredientSuggestionsList,
  handleIngredientInputFocus,
  handleIngredientInputBlur,
  applyIngredientSuggestion,
  addIngredient,
  getIngredientLabel,
  t,
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-4">
      <div className="flex-1 relative">
        <input
          type="text"
          value={currentIngredient}
          onChange={(e) => {
            const v = e.target.value;
            setCurrentIngredient(v);
            setShowIngredientSuggestions(v.trim().length > 0);
          }}
          onFocus={handleIngredientInputFocus}
          onBlur={handleIngredientInputBlur}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (
                showIngredientSuggestions &&
                ingredientSuggestionsList.length > 0
              ) {
                applyIngredientSuggestion(ingredientSuggestionsList[0]);
              } else {
                addIngredient(currentIngredient);
              }
            }
          }}
          placeholder={t("typeIngredient")}
          className="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500/60 focus:border-orange-500 text-slate-800 dark:text-slate-100 placeholder-slate-400 text-sm transition-all"
          autoComplete="off"
        />
        {showIngredientSuggestions && ingredientSuggestionsList.length > 0 && (
          <div
            className="absolute left-0 right-0 top-full mt-1 py-1 rounded-xl shadow-xl z-[100] max-h-60 overflow-y-auto border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800"
            onMouseDown={(e) => e.preventDefault()}
            role="listbox"
            aria-label={
              t("ingredientSuggestions") || "Suggestions d'ingrédients"
            }
          >
            {ingredientSuggestionsList.map((ingredient) => (
              <button
                key={ingredient}
                type="button"
                role="option"
                aria-selected={false}
                className="w-full text-left px-4 py-2.5 text-slate-800 dark:text-slate-100 hover:bg-orange-50 dark:hover:bg-orange-900/20 flex items-center gap-2 transition-colors"
                onClick={() => applyIngredientSuggestion(ingredient)}
              >
                <HiOutlinePlus className="w-4 h-4 text-orange-500 shrink-0" />
                <span className="truncate">
                  {getIngredientLabel(ingredient)}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={() => addIngredient(currentIngredient)}
        className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold rounded-xl shadow-lg transition-all shrink-0"
      >
        <HiOutlinePlus className="w-5 h-5" />
        {t("addButton")}
      </button>
    </div>
  );
}
